import { render, staticRenderFns } from "./ProviderDashboard.vue?vue&type=template&id=2ae11874&scoped=true&"
import script from "./ProviderDashboard.vue?vue&type=script&lang=js&"
export * from "./ProviderDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDashboard.vue?vue&type=style&index=0&id=2ae11874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae11874",
  null
  
)

export default component.exports